import {
    FontAwesomeIcon,
    FontAwesomeLayers,
    FontAwesomeLayersText,
} from '@fortawesome/vue-fontawesome';
import { AuthService, Firewall } from '@skinsoft/auth';

import { TranslationDataStore } from '@skinsoft/i18n';
import { Field, Form, LocalizedDate, LocalizedString } from '@skinsoft/ui';
import BootstrapVue from 'bootstrap-vue';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import VueKonva from 'vue-konva'
import Router from 'vue-router';
import Toasted from 'vue-toasted';

import {
    AliasDataStore,
    AliasDataStore as CollaboratorDataStore,
    ConditionReportDataStore,
    ExpressionDataStore,
    InstitutionDataStore,
    ItemDataStore,
    ManifestationDataStore,
    ThesaurusDataStore,
    ThesaurusTermDataStore,
    WorkDataStore,
    WorkspaceDataStore,
} from '@skinsoft/entity';

import { EntityFieldDataStore } from '@skinsoft/data-store';
import { MediaTransferHelper } from '@skinsoft/media-transfer-helper';

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('font-awesome-layers', FontAwesomeLayers);
Vue.component('font-awesome-layers-text', FontAwesomeLayersText);
Vue.component('s-form', Form);
Vue.component('s-field', Field);
Vue.component('s-firewall', Firewall);
Vue.component('s-localized-date', LocalizedDate);
Vue.component('s-localized-string', LocalizedString);

Vue.use(BootstrapVue);
Vue.use(Router);
Vue.use(Toasted);
Vue.use(VueKonva)
Vue.use(AuthService);
Vue.use(VueI18n);

Vue.use(TranslationDataStore);

Vue.use(AliasDataStore);
Vue.use(CollaboratorDataStore);
Vue.use(ThesaurusTermDataStore);
Vue.use(ThesaurusDataStore);
Vue.use(InstitutionDataStore);
Vue.use(EntityFieldDataStore)
Vue.use(WorkspaceDataStore)

Vue.use(ItemDataStore);
Vue.use(ManifestationDataStore)
Vue.use(ExpressionDataStore)
Vue.use(WorkDataStore);

Vue.use(ConditionReportDataStore);
Vue.use(MediaTransferHelper)

Vue.config.devtools = true;
Vue.config.productionTip = false;
